import type React from 'react';

export interface ContentField {
  id: string;
  label: string;
  show: string;
}

interface ContentFieldLabelProps {
  field: ContentField;
}

interface ContentFieldValueProps {
  field: ContentField;
}

export const ContentFieldLabel: React.FC<ContentFieldLabelProps> = ({ field }) => {
  const { label } = field;
  return <div>{label}</div>;
};

export const ContentFieldValue: React.FC<ContentFieldValueProps> = ({ field }) => {
  const { show } = field;
  return <div>{show}</div>;
};
